import { ProjectData } from "@/pages/Project";
import placeholder from "@/assets/placeholder.webp";
import "./performance.scss";
import { Container } from "react-bootstrap";
import decor from "@/assets/line-group-multi.png";

interface Props {
  project: Pick<ProjectData, "performance">;
}

const ProjectPerformance = ({ project }: Props) => {
  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <img src={decor} className="performance-decor" alt="" />
      <Container>
        <div className="project-performance">
          <div className="performance-info">
            <div className="title-2">{project.performance.title}</div>
            <div
              className="body"
              dangerouslySetInnerHTML={{ __html: project.performance.text }}
            />
          </div>
          <div className="performance-img-container">
            <div className="contact-head performance-tag title-4">
              {project.performance.tag}
            </div>
            <div className="performance-img-wrapper">
              <img src={project.performance.img || placeholder} alt={project.performance.tag} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default ProjectPerformance;
